import Router from 'vue-router';
import permissionRedirectHandler from '@/common/routes/handlers/permissionRedirectHandler';
import afterPermissionRedirectHandler from '@/common/routes/handlers/afterPermissionRedirectHandler';
import loadLanguagesHandler from '@/common/routes/handlers/loadLanguagesHandler';
import telemetryRouteHandler from '@/common/routes/handlers/telemetryRouteHandler';
import useAppModeStore from '@/common/store/pinia/appMode';

export default function ({ routes, baseURL, pinia }) {
  const appModeStore = useAppModeStore(pinia);

  const router = new Router({
    mode: appModeStore.preset.routerMode,
    base: baseURL,
    linkActiveClass: 'active',
    saveScrollPosition: true,
    parseQuery(query) {
      return JSON.parse(decodeURI(query) || '{}');
    },
    stringifyQuery(query) {
      const result = JSON.stringify(query);

      return result === '{}' ? '' : `?${result}`;
    },
    routes
  });

  if (!appModeStore.isFederated) {
    router.beforeEach(permissionRedirectHandler);
  }
  router.beforeEach(afterPermissionRedirectHandler);
  router.beforeEach(loadLanguagesHandler(pinia));
  router.afterEach(telemetryRouteHandler);

  if (appModeStore.preset.routerMode === 'abstract') {
    router.history.transitionTo(router.history.getCurrentLocation());
  }

  return router;
}
